import { Navigate } from "react-router-dom";

// The homepage now surfaces the full menu directly, so /menu just redirects home.
export default function MenuPage() {
  return <Navigate to="/" replace />;
}
